
import React, { ReactNode } from 'react';

interface UserTabContentProps {
  children: ReactNode;
  isLoading: boolean;
}

const UserTabContent: React.FC<UserTabContentProps> = ({ children, isLoading }) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-10">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  return <>{children}</>;
};

export default UserTabContent;
